// Add Up Redux Slices Here
// create redux slice function as reducer

// Every Page has their own redux slice function
import { createSlice } from '@reduxjs/toolkit';
import { notification } from 'antd';
import { authentication } from 'firebaseconfig';
import { toast } from 'react-toastify';
import { stopTokenRefresh } from 'util/tokenRefresh';

// import { notification } from 'antd';
// import history from 'utils/history';
// TODO -> Handle api errors

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: {},
    token: null,
    userLoading: true,
    authorized: false,
    imageCategories: []
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.authorized = true;
      window.localStorage.setItem('user', JSON.stringify(action.payload));
    },
    setToken: (state, action) => {
      window.localStorage.setItem('token', action.payload);
      state.token = action.payload;
    },

    // Must stay synchronous — async reducers return a Promise into state
    setLogout: (state) => {
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('user');
      state.user = {};
      state.authorized = false;
      state.token = null;
    },

    // Loading handler
    setUserLoading: (state, action) => {
      state.userLoading = action.payload;
    },
    setImageCategories: (state, action) => {
      state.imageCategories = action.payload;
    }
  }
});

export const {
  setUser,
  setToken,
  setLogout,
  setUserLoading,
  setImageCategories
} = authSlice.actions;

/** Firebase sign-out + clear auth state. Side effects stay out of the reducer. */
export const logout =
  ({ redirectTo = '/', showNotification = true, delayMs = 1000 } = {}) =>
  async (dispatch) => {
    stopTokenRefresh();

    try {
      await authentication.signOut();
    } catch (err) {
      // Still clear local session even if Firebase sign-out fails
      console.error('Firebase signOut failed', err);
    }

    dispatch(setLogout());

    if (showNotification) {
      toast.success('User Logout Successful');
    }

    if (redirectTo) {
      setTimeout(() => {
        window.location.href = redirectTo;
      }, delayMs);
    }
  };

// export const streamSelector = (state) => state.stream;

export default authSlice.reducer;
